<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
  >
    <validation-observer
      ref="observer"
    >
      <v-card>
        <v-card-title>
          ドライバー指示メモを編集
        </v-card-title>
        <v-divider />
        <v-card-text
          style="max-height: 60vh;overflow-y: auto"
        >
          <v-row>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                name="ドライバー指示メモ"
                rules="max:300"
              >
                <v-textarea
                  v-model="forms.driver_instruction"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="ドライバー指示メモ"
                  no-resize
                  outlined
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>ドライバー指示メモ</span>
                    <span class="ml-1">
                      ({{ forms.driver_instruction?.length || 0 }} / 300)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- 添付ファイル -->
          <v-row>
            <v-col cols="12">
              <dropzone-file
                :max-size="MANIFEST_ATTACHMENT.MAX_SIZE"
                :accepts="MANIFEST_ATTACHMENT.ACCEPTS"
                :max-file-size="MANIFEST_ATTACHMENT.MAX_FILE_SIZE"
                :alt-file-size-format="MANIFEST_ATTACHMENT.ALT_FILE_SIZE_FORMAT"
                :alt-file-format="MANIFEST_ATTACHMENT.ALT_FILE_FORMAT"
                :immediate-delete="MANIFEST_ATTACHMENT.IMMEDIATE_DELETE"
                :files.sync="files"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>

import { mapActions } from 'vuex'
import DropzoneFile from '../../../../components/DropzoneFile'
import { MANIFEST_ATTACHMENT } from '@/constants/appConst'

export default {
  name: 'AllocationOrderInstructionDialog',
  components: { DropzoneFile },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetDriverId: {
      type: Number,
      default: () => null,
    },
    targetOrderId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      forms: {
        id: null,
        driver_instruction: null,
        order_attachments: [],
      },
      files: [],
    }
  },
  computed: {
    MANIFEST_ATTACHMENT() {
      return MANIFEST_ATTACHMENT
    }
  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      this.files = []
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverAllocationOrderInstruction', {
      fetchDriverInstruction: 'edit',
      updateDriverInstruction: 'update',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      const params = new FormData()
      params.append('driver_instruction', this.forms.driver_instruction)
      for (const file of this.files) {
        // 新規 or 削除対象のみ
        if (!file.file && !file._destroy) continue

        if (file.id) {
          params.append('order_attachments_attributes[][id]', file.id)
        }
        params.append('order_attachments_attributes[][file]', file.file)
        if (file._destroy) {
          params.append('order_attachments_attributes[][_destroy]', file._destroy)
        }
      }
      this.updateDriverInstruction({ order_id: this.targetOrderId, params: params }).then(() => {
        this.$emit('registerEvent')
      })
    },
    /**
     * 初期値の設定
     */
    setVariable () {
      this.fetchDriverInstruction({ order_id: this.targetOrderId }).then((content) => {
        this.forms = content
        this.files = content.order_attachments
      })
    }
  }
}
</script>
